// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PutAiAgentsStatusByIdParam,
    PutAiAgentsStatusByIdBody,
    BaseResponseVoid,
} from '../../../types';

/**
 * 更新状态
 *
 * @export
 * @tags ai-agent-controller
 * @link [PUT] /aiAgents/status/{id}
 * @param id
 */
export function putAiAgentsStatusById(
    data: PutAiAgentsStatusByIdBody,
    options: ApiOptions<PutAiAgentsStatusByIdParam, never> & {
        segments: PutAiAgentsStatusByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<PutAiAgentsStatusByIdBody, PutAiAgentsStatusByIdParam, never>(
        '/aiAgents/status/{id}',
        { ...options, data, method: 'put', __$requestCalleeName: 'putAiAgentsStatusById' }
    );
}

export const meta = [
    { tags: ['ai-agent-controller'], path: '/aiAgents/status/{id}', method: 'put' },
];
